export default __webpack_public_path__ + "static/media/app-screenshot.8c894d3f.svg";